// extracted by mini-css-extract-plugin
module.exports = {"header":"b3_kf","header__content":"b3_kg","header__menu":"b3_kh","header__logo":"b3_kj","header__contacts":"b3_kk"};